import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["yes", "no", "acceptable", "input", "explainNo"]

  connect() {
    console.log("Hello from Verification Field Controller")
    this.afterChange()
  }

  reset() {
    if (this.hasYesTarget) {
      this.yesTarget.classList.add("opacity-20")
    }
    if (this.hasNoTarget) {
      this.noTarget.classList.add("opacity-20")
    }
    if (this.hasAcceptableTarget) {
      this.acceptableTarget.classList.add("opacity-20")
    }
    this.hideExplainNo()
  }

  getValue() {
    return this.inputTarget.value;
  }

  showExplainNo() {
    if (!this.hasExplainNoTarget) { return }

    this.noTarget.parentElement.appendChild(this.explainNoTarget)
    this.explainNoTarget.classList.remove("hidden")
    this.explainNoTarget.querySelectorAll('textarea')[0].required = true
  }

  hideExplainNo() {
    if (!this.hasExplainNoTarget) { return }
    this.explainNoTarget.classList.add("hidden")
    this.explainNoTarget.querySelectorAll('textarea')[0].required = false
  }

  afterChange() {
    this.reset();
    switch (this.getValue()) {
      case "yes":
        this.yesTarget.classList.remove("opacity-20")
        break;
      case "no":
        this.noTarget.classList.remove("opacity-20")
        this.showExplainNo()
        break;
      case "acceptable":
        this.acceptableTarget.classList.remove("opacity-20")
        break;
    }
    this.dispatch("changed")
  }

  setYes() {
    this.inputTarget.value = "yes"
    this.afterChange()
  }

  setNo() {
    this.inputTarget.value = "no"
    this.afterChange()
  }

  setAcceptable() {
    this.inputTarget.value = "acceptable"
    this.afterChange()
  }
}
